import { lazy } from 'react';

export const QuestionList = lazy(() => import('./QuestionList'));
export const AddQuestion = lazy(() => import('./AddQuestion'));
export const UpdateQuestion = lazy(() => import('./UpdateQuestion'));
export const QuestionFilter = lazy(() => import('./QuestionFilter'));
